/**
 * Local Storage Service
 * Handles storing and retrieving user and token data from local storage
 */

const STORAGE_KEYS = {
  USER: 'user',
  TOKEN: 'authToken',
  FCM_TOKEN: 'fcm_token',
  CHATBOT_ID: 'chatbotId',
} as const;

export const localStorageService = {
  // User operations
  storeUser: (user: any): void => {
    try {
      localStorage.setItem(STORAGE_KEYS.USER, JSON.stringify(user));
    } catch (error) {
      console.error('Error storing user:', error);
    }
  },

  getUser: (): any => {
    try {
      const user = localStorage.getItem(STORAGE_KEYS.USER);
      return user ? JSON.parse(user) : null;
    } catch (error) {
      console.error('Error retrieving user:', error);
      return null;
    }
  },

  removeUser: (): void => {
    try {
      localStorage.removeItem(STORAGE_KEYS.USER);
    } catch (error) {
      console.error('Error removing user:', error);
    }
  },

  // Token operations
  storeToken: (token: string): void => {
    try {
      localStorage.setItem(STORAGE_KEYS.TOKEN, token);
    } catch (error) {
      console.error('Error storing token:', error);
    }
  },

  storeChatbotId: (chatbotId: string): void => {
    try {
      localStorage.setItem(STORAGE_KEYS.CHATBOT_ID, chatbotId);
    } catch (error) {
      console.error('Error storing chatbot ID:', error);
    }
  },

  getChatbotId: (): string | null => {
    try {
      return localStorage.getItem(STORAGE_KEYS.CHATBOT_ID);
    } catch (error) {
      console.error('Error retrieving chatbot ID:', error);
      return null;
    }
  },

  getToken: (): string | null => {
    try {
      return localStorage.getItem(STORAGE_KEYS.TOKEN);
    } catch (error) {
      console.error('Error retrieving token:', error);
      return null;
    }
  },

  removeToken: (): void => {
    try {
      localStorage.removeItem(STORAGE_KEYS.TOKEN);
    } catch (error) {
      console.error('Error removing token:', error);
    }
  },

  // Clear all
  clearAll: async () => {
    try {
      localStorage.removeItem(STORAGE_KEYS.USER);
      localStorage.removeItem(STORAGE_KEYS.TOKEN);
      localStorage.removeItem(STORAGE_KEYS.FCM_TOKEN);
      localStorage.removeItem('isRemoteAccess');
      localStorage.removeItem('remoteAccessLogId');
      localStorage.removeItem(STORAGE_KEYS.CHATBOT_ID);
      // remove cookies refresh toke 
      document.cookie = 'refreshToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
      new Promise((resolve) => setTimeout(resolve, 500)); // Small delay to ensure all operations complete
    } catch (error) {
      console.error('Error clearing storage:', error);
    }
  },
};
